import React from "react";
import Table, {
  TableRow,
  TableRowCell,
  Tbody,
  Thead,
  TheadCell,
  TheadRow,
} from "src/components/Table";
import { MdDelete, MdEdit } from "react-icons/md";

import { useTable } from "react-table";

import styles from "./styles.module.scss";

const InteractionFlowsTable = ({ onEdit, onDelete, loading, items }) => {
  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Info",
        accessor: "info",
      },
      {
        Header: "Input Attributes",
        accessor: ({ inputAttributes }) => (inputAttributes || []).join(","),
      },
      {
        Header: "Step Count",
        accessor: ({ steps }) => (steps || []).length,
      },
      {
        Header: "Actions",
        accessor: "id",
        Cell: ({ row }) => (
          <div>
            <MdEdit
              className={styles.iconButton}
              onClick={() => onEdit && onEdit(row.original)}
            />
            <MdDelete
              className={styles.iconButton}
              onClick={() => onDelete && onDelete(row.original)}
            />
          </div>
        ),
      },
    ],
    [onDelete, onEdit]
  );
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data: items || [] });

  return (
    <Table
      loading={loading}
      isEmpty={!items?.length}
      className={styles.table}
      {...getTableProps()}
    >
      <Thead>
        {headerGroups.map((headerGroup) => (
          <TheadRow {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <TheadCell {...column.getHeaderProps()}>
                {column.render("Header")}
              </TheadCell>
            ))}
          </TheadRow>
        ))}
      </Thead>
      <Tbody {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          return (
            <TableRow {...row.getRowProps()}>
              {row.cells.map((cell) => {
                return (
                  <TableRowCell {...cell.getCellProps()}>
                    {cell.render("Cell")}
                  </TableRowCell>
                );
              })}
            </TableRow>
          );
        })}
      </Tbody>
    </Table>
  );
};

export default InteractionFlowsTable;
